import { orderBy } from 'lodash';
import { css } from 'styled-components';
import type {
  GroupedFormOption,
  BaseFormOption,
} from 'src/components/form/form-option';
import { Colors } from 'src/styles';
import { cn } from 'src/utils/cn';

export type SortByOptions = 'label' | 'value' | 'manual';

export function applySortBy<T extends BaseFormOption<string | null>>(
  sortBy: SortByOptions,
  options: T[]
) {
  switch (sortBy) {
    case 'manual':
      return options;
    case 'label':
      return orderBy(
        options,
        // place empty value on top, no matter what the actual label is
        [(item) => (item.value ? item.label.toLowerCase() : '')],
        ['asc']
      );
    case 'value':
      return orderBy(
        options,
        // place empty value on top, no matter what the actual label is
        [(item) => (item.value ? item.value.toLowerCase() : '')],
        ['asc']
      );
  }
}

export function applyGroupSortBy<T extends GroupedFormOption<string>>(
  sortBy: SortByOptions,
  options: T[]
) {
  switch (sortBy) {
    case 'manual':
      return options;
    case 'label':
    case 'value': // groups have no value, so we treat it as label
      return orderBy(options, [(item) => item.label.toLowerCase()], ['asc']);
  }
}

export const selectOptionBaseStyle = css`
  color: ${Colors.brand};
  word-break: break-word;
  margin: 0.1rem;
  border-radius: 0.4rem;
  user-select: none;
  padding: 1rem;
  padding-left: 2rem;

  /* see https://github.com/ariakit/ariakit/issues/845#issuecomment-785493623 */
  pointer-events: initial !important;
`;

export const selectOptionBaseClasses = cn(
  `
    m-[0.1rem] rounded-[0.4rem] p-[1rem] pl-[2rem] wrap-break-word
    text-legacy-brand select-none
  `,
  // see https://github.com/ariakit/ariakit/issues/845#issuecomment-785493623
  '[pointer-events:initial]!'
);
